/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Col_VarianceInputs */

const vi_stocktake_line_col_variance = /** @type {(inputs: Stocktake_Line_Col_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chênh`)
};

/**

* @param {Stocktake_Line_Col_VarianceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_col_variance = /** @type {((inputs?: Stocktake_Line_Col_VarianceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Col_VarianceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_col_variance(inputs)
});